import { useRef, useState, useEffect } from "react";

import {
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
import { useNavigate, Link } from "react-router-dom";
import TopBar from "./TopBar";
import { useStateDistrict } from "../../utils/Utilities.js"; // adjust path if needed


const CreateCustomer = () => {

  const [showValidation, setShowValidation] = useState(false);

  const {
    statesList,
    districtsList,
    stateId,
    setStateId,
    district,
    setDistrict,
    loadingStates,
    loadingDistricts,
  } = useStateDistrict();

  const axiosPrivate = useAxiosPrivate();
  const userRef = useRef();
  const errRef = useRef();
  const { auth } = useAuth();
  const CREATE_CUSTOMER_URL = "api/create-customer";

  const [responseMessage, setResponseMessage] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [CustomerAddress1, setCustomerAddress1] = useState("");
  const [CustomerAddress2, setCustomerAddress2] = useState("");
  const [CustomerEmail, setCustomerEmail] = useState("");
  const [Pincode, setPincode] = useState("");
  const [City, setCity] = useState("");
  const [State, setState] = useState("");
  const [Phone, setPhone] = useState("");
  const [Mobile, setMobile] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [validEmail, setValidEmail] = useState(false);
  const [validName, setValidName] = useState(false);

  const [nameFocus, setNameFocus] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);

  const [errMsg, setErrMsg] = useState("");
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);


  useEffect(() => {
    const fetchCustomerCategories = async () => {
      try {
        const res = await axiosPrivate.get("/api/list-customer-categories");
        setCategories(res.data);
      } catch (error) {
        console.error("Failed to load categories", error);
      }
    };

    fetchCustomerCategories();
  }, []);





  useEffect(() => {
    userRef.current.focus();
  }, []);


  const postCreateCustomer = async () => {
    // ✅ Validation: customer type must be selected
    if (!selectedCategory) {
      alert("Please select Customer Type");
      return; // stop submission
    }
    try {
      const data = {
        customer_name: customerName,
        franchise_id: auth.franchise_id,
        customer_address1: CustomerAddress1,
        customer_address2: CustomerAddress2,
        customer_pincode: Pincode,
        customer_city: City,

        customer_phone: Phone,
        customer_mobile: Mobile,
        customer_email: CustomerEmail,
        category: selectedCategory,
        state_id: stateId,
        district_id: district,
        gst_number: gstNumber

      };

      const response = await axiosPrivate.post(CREATE_CUSTOMER_URL, data);

      // ✅ Success response
      if (response.data?.message) {
        setResponseMessage({
          type: "success",
          text: response.data.message,
          customerId: response.data?.data?.customer_id || null,
        });
      } else {
        setResponseMessage({
          type: "success",
          text: "Customer created successfully!",
        });
      }
    } catch (error) {
      console.error("Error:", error);

      // ✅ Handle error structure
      const errData = error.response?.data;

      let messageText = "An unexpected error occurred.";
      if (Array.isArray(errData?.message)) {
        // Validation error array
        messageText = errData.message.map((m) => m.msg).join(", ");
      } else if (typeof errData?.message === "string") {
        messageText = errData.message;
      }

      setResponseMessage({
        type: "error",
        text: messageText,
      });
    }
  };








  return (
    <>



      <section className="userregbody">
        <p
          ref={errRef}
          className={errMsg ? "errmsg" : "offscreen"}
          aria-live="assertive"

        >
          {errMsg}
        </p>

        {responseMessage && (
          <div
            className={`alert ${responseMessage.type === "success" ? "alert-success" : "alert-danger"
              }`}
            role="alert"
          >
            {responseMessage.text}
            {responseMessage.customerId && (
              <div>Customer ID: {responseMessage.customerId}</div>
            )}
          </div>
        )}


        <div className=" wrapper3">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          <button onClick={() => navigate("/ListCustomers")}
            type="button" className="btn btn-success ms-auto d-block top-bt">Customer List</button>
          <form onSubmit={(e) => { e.preventDefault(); postCreateCustomer(); }}>


            <h3>Create Direct Customer</h3>
            <Row>
              <Col>

                <div className=" input-boxs">
                  <label htmlFor="name">Name<sup>*</sup></label>

                  <input
                    type="text"
                    id="name"
                    placeholder=""
                    autoComplete="off"
                    ref={userRef} // Attach the ref to this input

                    onChange={(e) => setCustomerName(e.target.value)}
                    value={customerName}
                    required
                    aria-invalid={validName ? "false" : "true"}
                    aria-describedby="namenote"
                    onFocus={() => setNameFocus(true)}
                    onBlur={() => setNameFocus(false)}
                  />
                  {/* <i className="bx bxs-user"></i> */}
                  <p
                    id="namenote"
                    className={
                      nameFocus && !validName ? "instructions" : "offscreen"
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                    Name is required!.
                  </p>

                </div>
              </Col>
              <Col>
                <div className=" input-boxs">
                  <label htmlFor="email">Email<sup>*</sup></label>

                  <input
                    type="text"
                    id="email"
                    autoComplete="off"
                    placeholder=""

                    onChange={(e) => setCustomerEmail(e.target.value)}
                    value={CustomerEmail}
                    required
                    aria-invalid={validEmail ? "false" : "true"}
                    aria-describedby="emailnote"
                    onFocus={() => setEmailFocus(true)}
                    onBlur={() => setEmailFocus(false)}

                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}
                  <p
                    id="emailnote"
                    className={
                      emailFocus && CustomerEmail && !validEmail
                        ? "instructions"
                        : "offscreen"
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                    E-mail is required!.
                  </p>

                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className=" input-boxs">
                  <label htmlFor="role">Address Line 1<sup>*</sup></label>
                  <input
                    type="text"
                    id="CustomerAddress1"
                    autoComplete="off"
                    onChange={(e) => setCustomerAddress1(e.target.value)}
                    value={CustomerAddress1}
                    required
                  />
                </div>

              </Col>
              <Col>

                <div className=" input-boxs">
                  <label htmlFor="Username">Address Line 2<sup>*</sup></label>
                  <input
                    type="text"
                    id="CustomerAddress2"
                    autoComplete="off"
                    placeholder=""

                    onChange={(e) => setCustomerAddress2(e.target.value)}
                    value={CustomerAddress2}
                    required

                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}

                </div>
              </Col>
            </Row>


            <Row>
              <Col>

                <div className=" input-boxs">
                  <label htmlFor="password">Pincode<sup>*</sup></label>
                  <input
                    type="text"
                    id="Pincode"
                    autoComplete="off"
                    placeholder=""

                    onChange={(e) => setPincode(e.target.value)}
                    value={Pincode}
                    required

                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}

                </div>
              </Col>
              <Col>

                <div className=" input-boxs">
                  <label htmlFor="confirm_pwd">City<sup>*</sup></label>
                  <input
                    type="text"
                    id="City"
                    autoComplete="off"
                    placeholder=" "

                    onChange={(e) => setCity(e.target.value)}
                    value={City}
                    required
                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}


                </div>
              </Col>
            </Row>


            <Row>
              <Col>
                <div className=" input-boxs">
                  <label htmlFor="confirm_pwd">Phone<sup>*</sup></label>
                  <input
                    type="text"
                    id="Phone"
                    autoComplete="off"
                    placeholder=" "

                    onChange={(e) => setPhone(e.target.value)}
                    value={Phone}
                    required
                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}
                </div>
              </Col>
              <Col>
                <div className=" input-boxs">
                  <label htmlFor="confirm_pwd">Mobile<sup>*</sup></label>
                  <input
                    type="text"
                    id="Mobile"
                    autoComplete="off"
                    placeholder=" "

                    onChange={(e) => setMobile(e.target.value)}
                    value={Mobile}
                    required
                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}
                </div>
              </Col>

            </Row>
            <Row>
              <Col>
                <div className="newinput-boxs">
                  <label htmlFor="selectedCategory">Customer category<sup>*</sup></label>
                  <select
                    className="newregselect"
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    <option value="">Select Category</option>

                    {categories.map((cat) => (
                      <option key={cat.value} value={cat.value}>
                        {cat.text}
                      </option>
                    ))}
                  </select>

                </div>
              </Col>
              <Col>
                <div className=" input-boxs">
                  <label htmlFor="confirm_pwd">GST Number</label>
                  <input
                    type="text"
                    id="gstNumber"
                    autoComplete="off"
                    placeholder=" "

                    onChange={(e) => setGstNumber(e.target.value)}
                    value={gstNumber}

                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}
                </div>
              </Col>

              <Col>

                <div className="input-boxs">
                  <label>State<sup>*</sup></label>

                  <select
                    className="newregselect"
                    value={stateId}
                    onChange={(e) => setStateId(e.target.value)}
                    required
                  >
                    <option value="">Select State</option>

                    {statesList.map((state) => (
                      <option key={state.state_id} value={state.state_id}>
                        {state.state_name} - ({state.state_code})
                      </option>
                    ))}
                  </select>

                  {showValidation && !stateId && (
                    <div className="mt-1 reqstyl">*State is required</div>
                  )}
                </div>
              </Col>

              <Col>

                <div className="input-boxs">
                  <label>District<sup>*</sup></label>

                  <select
                    className="newregselect"
                    value={district}
                    onChange={(e) => setDistrict(e.target.value)}
                    disabled={!stateId}
                    required
                  >
                    <option value="">Select District</option>

                    {districtsList.map((dist) => (
                      <option key={dist.district_id} value={dist.district_id}>
                        {dist.district_name} - ({dist.district_code})
                      </option>
                    ))}
                  </select>

                  {showValidation && !district && (
                    <div className="mt-1 reqstyl">*District is required</div>
                  )}
                </div>
              </Col>

            </Row>
            <Row>



            </Row>
            <center>
              <button type="submit" className="btn regbutton"> Submit</button>
            </center>

          </form>
        </div>
      </section>


      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default CreateCustomer;
